import * as React from 'react';
import { ButtonElement } from './Button.styles';

export type ButtonType = 'button' | 'submit' | 'reset';

export type ButtonMode = 'solid' | 'outline' | 'link';

export type ButtonProps = {
  label: string
  type: ButtonType;
  id?: string;
  mode?: ButtonMode;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent) => void;
  className?: string;
  tabIndex?: number;
};

const Button = ({
  label,
  type,
  id,
  mode = 'solid',
  disabled,
  onClick,
  className = '',
  tabIndex,
}: ButtonProps): React.ReactElement => {
  const classNames = `${mode} ${className}`;
  return (
    <ButtonElement
      className={classNames}
      type={type}
      id={id}
      disabled={disabled}
      onClick={onClick}
      tabIndex={tabIndex}
    >
      <span>{label}</span>
    </ButtonElement>
  );
};

export default Button;
